/* 2020.03.11 Youtube 영상 재생 로직 :: S */
/**
 * Youtube iFrame API 세팅
 * @type {HTMLScriptElement}
 */
var tag = document.createElement("script");
tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
var players = [];
window.onYouTubeIframeAPIReady = function() {
    var i = 0;

    $(".videoPlayBox").each(function(index){
        var id = $(this).find("iframe").attr("id");
        players.push(new YT.Player(id, {
            events: {
                'onReady': onPlayerReady,
                'onStateChange': onPlayerStateChange
            }
        }));
    });
};
function onPlayerReady(event){
}
function onPlayerStateChange(event){
}

$(function(){
    var $videoArea = $(".videoPlayBox");

    if($videoArea.length > 0){
        $videoArea.each(function(index){
            var _this = $(this);
            _this.on("click", ".vdo_cover_img > a", function(e){
                e.preventDefault();

                $(this).parent().css("display", "none");
                $(this).closest(".videoPlayBox").find(".vdo_wrap").css("display", "block");

                players[index].playVideo();
            });
        });
    }
});
/* 2020.03.11 Youtube 영상 재생 로직 :: E */